class Watermark {
  constructor(element, duration = 2100) {
    const props = {
      element,
      duration,
      typeof: 'Watermark',
    };

    Object.assign(this, props);
  }

  play() {
    this.element.classList.add('watermark--animate');

    this.timeout = requestTimeout(() => {
      this.stop();
    }, this.duration);
  }

  stop() {
    this.element.classList.remove('watermark--animate');
  }
}
